import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronDown } from 'lucide-react';
export const HeroSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const handleBeginJourney = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsScrolling(true);
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(() => setIsScrolling(false), 1000);
    }
  };
  return <>
      <section id="hero" className="relative w-full min-h-screen bg-black flex items-center justify-center overflow-hidden" data-id="element-1506" data-mp="2mtnmwriufhm4">
        {/* Background image */}
        <div className="absolute inset-0" data-id="element-1507" data-mp="3fhtadm1a7kpn">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxKq2k9j3qcBE1TheAWARz/Experience_image.png" alt="Life in the Sikh Kingdoms" className="w-full h-full object-cover opacity-40" data-id="element-1508" data-mp="3k9b7fz06p15c" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black" data-id="element-1509" data-mp="2beyeeox5y23d"></div>
        </div>
        {/* Content */}
        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-1510" data-mp="2p7ejdv9mka6x">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-1511" data-mp="2kd22nszj9cyv">
            <p className="text-amber-400/50 tracking-[0.25em] text-[10px] uppercase mb-3 font-light" data-id="element-1512" data-mp="383ny8kscp4rz">
              Presented by Akal Steel
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.3
        }} data-id="element-1513" data-mp="1dr7ubqn122qa">
            <p className="text-amber-400 tracking-[0.3em] text-xs md:text-sm uppercase mb-8 font-light" data-id="element-1514" data-mp="3dth5hhlp8bat">
              1799 – 1839 · Lahore Darbar
            </p>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-8 tracking-tight leading-none" data-id="element-1515" data-mp="3mt48g7u2tp5z">
              LIFE IN THE
              <br data-id="element-1516" data-mp="3rre38hbw2nr2" />
              <span className="text-amber-400" data-id="element-1517" data-mp="3rrxb157trvrd">SIKH KINGDOMS</span>
            </h1>
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-12 text-white/80" data-id="element-1518" data-mp="kl1ncd6omm0">
              <div className="text-center" data-id="element-1519" data-mp="5d4e2604xbp8">
                <p className="text-sm tracking-[0.2em] uppercase mb-1" data-id="element-1520" data-mp="abfpgl62vu9k">
                  Immersive
                </p>
                <p className="text-xs" data-id="element-1521" data-mp="ee2c87nw6ozw">Sensory Experience</p>
              </div>
              <div className="hidden md:block w-px h-12 bg-white/20" data-id="element-1522" data-mp="jc43hfvh1umg"></div>
              <div className="text-center" data-id="element-1523" data-mp="ja14w7g96t64">
                <p className="text-sm tracking-[0.2em] uppercase mb-1" data-id="element-1524" data-mp="23uocmw20hrtu">
                  From The Court
                </p>
                <p className="text-xs" data-id="element-1525" data-mp="1yts23zn5n7fg">Of Maharaja Ranjit Singh</p>
              </div>
              <div className="hidden md:block w-px h-12 bg-white/20" data-id="element-1526" data-mp="1uuj7yto7d7jd"></div>
              <div className="text-center" data-id="element-1527" data-mp="1pv6jy5llhuf7">
                <p className="text-sm tracking-[0.2em] uppercase mb-1" data-id="element-1528" data-mp="1pwhpoaylpc8y">
                  Toronto
                </p>
                <p className="text-xs" data-id="element-1529" data-mp="2mmqozv7melya">Summer 2026</p>
              </div>
            </div>
            <motion.a href="#about" onClick={handleBeginJourney} className="group relative inline-block" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={isScrolling ? {
            y: [0, -10, 0],
            opacity: [1, 0.5, 1]
          } : {}} transition={{
            duration: 0.6,
            ease: 'easeInOut'
          }} data-id="element-1530" data-mp="2ilf76buzn50n">
              <div className="relative border-2 border-white/30 hover:border-amber-400 transition-colors duration-300 px-12 py-4" data-id="element-1531" data-mp="2c2it5iku6sea">
                <span className="text-white tracking-[0.3em] text-sm uppercase font-light flex items-center gap-3" data-id="element-1532" data-mp="2h1vefyw27rer">
                  Begin Journey
                  <motion.div animate={{
                  y: [0, 3, 0]
                }} transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-1533" data-mp="38s8kadu0cs2s">
                    <ChevronDown className="w-4 h-4" data-id="element-1534" data-mp="3nozb3ypm8vgs" />
                  </motion.div>
                </span>
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-400 group-hover:w-full transition-all duration-500" data-id="element-1535" data-mp="3sgr0w70y6x5v"></div>
              </div>
            </motion.a>
          </motion.div>
        </div>
        {/* Scroll indicator */}
        <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-1536" data-mp="1ntbvup3skfd">
          <div className="w-px h-16 bg-gradient-to-b from-transparent via-white/50 to-transparent" data-id="element-1537" data-mp="3ivezca992mw9"></div>
        </motion.div>
      </section>
      {/* Expanded Modal */}
      <AnimatePresence data-id="element-1538" data-mp="3sucuhw16leo8">
        {isExpanded && <motion.div className="fixed inset-0 z-50 bg-black" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} data-id="element-1539" data-mp="3sv5t29pzkxva">
            <button onClick={() => setIsExpanded(false)} className="absolute top-8 right-8 z-50 text-white hover:text-amber-400 transition-colors" data-id="element-1540" data-mp="135u3btwxg7wy">
              <X className="w-8 h-8" data-id="element-1541" data-mp="1f6sne4ej9omp" />
            </button>
            <div className="w-full h-full flex items-center justify-center p-8" data-id="element-1542" data-mp="1f9eu61tlo03v">
              <motion.div className="max-w-7xl w-full" initial={{
            scale: 0.9,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-1543" data-mp="1k6y8f1qascvt">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxKq2k9j3qcBE1TheAWARz/Experience_image.png" alt="Life in the Sikh Kingdoms - Full View" className="w-full h-auto object-contain" data-id="element-1544" data-mp="11evx85wfdosy" />
                <motion.div className="text-center mt-8" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3
            }} data-id="element-1545" data-mp="dpt709nq6nmu">
                  <p className="text-white/60 text-sm tracking-wider" data-id="element-1546" data-mp="3nfgouvst9z5s">
                    Illuminarium Toronto · Distillery District
                  </p>
                </motion.div>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};